/* eslint-disable @typescript-eslint/no-explicit-any */
// ** React Imports
import { NavLink, useLocation } from "react-router";

// ** Third Party Components
import classnames from "classnames";
import { useTranslation } from "react-i18next";

// ** Reactstrap Imports
import { Badge } from "reactstrap";
import { isMenuNavLinkActive } from "@src/@core/layouts/utils";

const VerticalNavMenuLink = ({ item }: any) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isExternal = item.externalLink === true;
  const isActive = isMenuNavLinkActive(item.navLink, pathname);

  const linkClassName =
    isActive && !item.disabled
      ? "d-flex align-items-center active"
      : "d-flex align-items-center";

  return (
    <li
      className={classnames({
        "nav-item": !item.children,
        disabled: item.disabled,
        active: isActive,
      })}
    >
      {isExternal ? (
        <a
          href={item.navLink || "/"}
          className={linkClassName}
          target={item.newTab ? "_blank" : undefined}
          onClick={(e) => {
            if (!item.navLink || item.navLink === "#" || item.disabled) {
              e.preventDefault();
            }
          }}
        >
          {item.icon}
          <span className="menu-item text-truncate">{t(item.title)}</span>
          {item.badge && item.badgeText ? (
            <Badge className="ms-auto me-1" color={item.badge} pill>
              {item.badgeText}
            </Badge>
          ) : null}
        </a>
      ) : (
        <NavLink
          to={item.navLink || "/"}
          end
          className={() => linkClassName}
          aria-current={isActive ? "page" : undefined}
          target={item.newTab ? "_blank" : undefined}
          onClick={(e) => {
            if (
              !item.navLink ||
              item.navLink.length === 0 ||
              item.navLink === "#" ||
              item.disabled === true
            ) {
              e.preventDefault();
            }
          }}
        >
          {item.icon}
          <span className="menu-item text-truncate">{t(item.title)}</span>
          {item.badge && item.badgeText ? (
            <Badge className="ms-auto me-1" color={item.badge} pill>
              {item.badgeText}
            </Badge>
          ) : null}
        </NavLink>
      )}
    </li>
  );
};

export default VerticalNavMenuLink;
